import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_2 = { class: "card-header pb-2 d-flex align-items-center justify-content-between gap-2 flex-wrap" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "text-danger" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive tr-scroll" }
const _hoisted_7 = { class: "table align-middle mb-0" }
const _hoisted_8 = {
  key: 0,
  class: "d-block text-muted"
}
const _hoisted_9 = { class: "text-end text-danger text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.refunds.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h5", _hoisted_3, "Remboursements déduits (" + _toDisplayString(_ctx.refunds.length) + ")", 1),
          _createElementVNode("b", _hoisted_4, "− " + _toDisplayString(_ctx.format(_ctx.total)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-muted small mb-2" }, "Montants remis aux destinataires avec les fonds d'encaissement du livreur (frais de service exclus).", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "Demande"),
                  _createElementVNode("th", { scope: "col" }, "Colis"),
                  _createElementVNode("th", { scope: "col" }, "Destinataire"),
                  _createElementVNode("th", { scope: "col" }, "Remboursé le"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-end"
                  }, "Montant")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.refunds, (r) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: r.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("b", null, _toDisplayString(r.ref), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(r.parcel_code), 1),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(r.receiver), 1),
                      (r.city_name)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(r.city_name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(r.refunded_at)), 1),
                    _createElementVNode("td", _hoisted_9, "− " + _toDisplayString(_ctx.format(r.amount)), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}